import vars from '../globals';
import {mixerStop} from './composition';
import {Howl, Howler} from 'howler';

let cardMusic = [];
const $cards = $('.card');

const audioLoader = () => {
	$(window).on('resize scroll', () => {
		$cards.each((i, card) => {
			let $card = $(card);

			let cardTop = $card.offset().top;
			let cardHeight = $card.height();

			let scrollTop = window.pageYOffset;
			let scrollTopHeight = scrollTop + window.innerHeight;

			if (scrollTopHeight >= cardTop && cardTop + cardHeight >= scrollTop && !$card.hasClass('isAudioLoaded') && cardTop !== 0) {
				$card.addClass('isAudioLoaded');

				let id = $card.data('player');

				cardMusic[id].load();
			}
		});
	});
};

function progressSound($progress, index) {
	let seek = Math.round(cardMusic[index].seek()) || 0;

	$progress.css({
		width: `${seek / cardMusic[index].duration() * 100 || 0}%`, // stylelint-disable-line
	});

	// если играет музыка, то перерисовываем каждую секунду
	if (cardMusic[index].playing()) {
		setTimeout(() => {
			progressSound($progress, index);
		}, 1000);
	}
}

function howl(file, index, $progress) {
	cardMusic[index] = new Howl({
		src: [file],
		usingWebAudio: true,
		preload: false,
		onplayerror() {
			cardMusic[index].once('unlock', () => {
				cardMusic[index].play();
			});
		},
	});

	cardMusic[index].on('play', () => {
		progressSound($progress, index);

		if ($progress.closest('.card').hasClass('is-mute')) {
			cardMusic[index].mute(true);
		} else {
			cardMusic[index].mute(false);
		}
	});

	cardMusic[index].on('end', () => {
		if ($cards.hasClass('is-play')) {
			const name = $cards.find('card__name').text();

			vars.$document.trigger('card-audio-end', name);
			$cards.removeClass('is-play');
		}
	});

	cardMusic[index].once('load', () => {
		if (Howler.ctx && Howler.ctx.state && Howler.ctx.state === 'suspended') {
			Howler.ctx.resume().then(() => {
				// eslint-disable-next-line no-console
				console.log('AudioContext resumed!');
			});
		}
	});

	cardMusic[index].once('loaderror', (e, j) => {
		// eslint-disable-next-line no-console
		console.log(e, j);
	});
}

function cardClick(e, index, name) {
	for (let track of Object.entries(cardMusic)) {
		if (cardMusic[index] !== track[1]) {
			track[1].stop();
		}
	}

	if (cardMusic[index].playing()) {
		cardMusic[index].pause();
		vars.$document.trigger('card-audio-stop');
	} else {
		$cards.not(`[data-player="${index}"]`).each((i, card) => {
			if ($(card).hasClass('is-play')) {
				$(card).removeClass('is-play');
			}
		});

		cardMusic[index].play();
		vars.$document.trigger('card-audio-play', name);
	}
}

function init() {
	$cards.each((i, card) => {
		const $card = $(card);
		const $progress = $card.find('.card__progress');
		const $timeline = $card.find('.card__timeline');
		const $play = $card.find('.card__play');
		const $mute = $card.find('.card__mute');
		const $file = $card.find('.card__file');

		howl($file.attr('src'), i + 1, $progress);

		$play.on('click.card', (e) => {
			const index = $(e.currentTarget).closest('.card').data('player');
			const name = $card.find('.card__name').text();

			$card.toggleClass('is-play');
			mixerStop();
			cardClick(e, index, name);

			if ($card.hasClass('is-mute')) {
				cardMusic[index].mute(true);
			} else {
				cardMusic[index].mute(false);
			}
		});

		$timeline.on('click.card', (e) => {
			const index = $(e.currentTarget).closest('.card').data('player');
			const x = e.offsetX / $(e.currentTarget).width();
			const seek = Math.round(cardMusic[index].seek()) || 0;
			e.preventDefault();

			cardMusic[index].seek(cardMusic[index].duration() * x);
		});

		$mute.on('click.card', (e) => {
			const index = $(e.currentTarget).closest('.card').data('player');
			const name = $card.find('.card__name').text();

			$card.toggleClass('is-mute');

			if (cardMusic[index].mute()) {
				cardMusic[index].mute(false);
			} else {
				cardMusic[index].mute(true);

				vars.$document.trigger('card-audio-mute', name);
			}
		});
	});

	audioLoader();
}

function cardAudioStop() {
	for (let track of Object.entries(cardMusic)) {
		if (track[1].playing()) {
			track[1].stop();
		}
	}

	$cards.removeClass('is-play');
}

function destroy() {
	$cards.each((i, card) => {
		const $card = $(card);

		$card.find('.card__play').off('.card');
		$card.find('.card__mute').off('.card');
		$card.find('.card__timeline').off('.card');
		$card.removeClass('is-play');
		$card.removeClass('is-mute');

		$card.find('.card__progress').css({
			width: '0%',
		});
	});

	cardAudioStop();
}

export default {
	init,
	destroy,
	cardAudioStop,
};
